import React, { FC } from "react";
import { BookingPricingSummary } from "../../../BookingPricingSummary/BookingPricingSummary";
import { ServicePricingSummary } from "../../../../../Partials/PricingHighlight/ServicePricingSummary.csharp";
import { ModalLayout } from "../Modal";

type PricingSummaryModalProps = {
	onClose: () => void;
	isOpen: boolean;
	pricingSummary: ServicePricingSummary;
};

export const PricingSummaryModal: FC<PricingSummaryModalProps> = ({
	onClose,
	isOpen,
	pricingSummary,
}) => {
	return (
		<ModalLayout
			className="PricingSummaryModal"
			onClose={onClose}
			isOpen={isOpen}
			heading={pricingSummary.serviceName}
		>
			<BookingPricingSummary {...pricingSummary} />
		</ModalLayout>
	);
};
